import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
const problems = [{
  num: '01 / 04',
  title: 'El problema de evaluar sin criterio',
  sin: 'Inventás el examen el domingo a la noche, sin criterios claros, y después no sabés bien cómo calificar ni qué decirle a la familia.',
  con: '18 evaluaciones listas para fotocopiar con hojas de claves, rúbricas analíticas y planillas de registro. Todo alineado al CFE y listo para mostrar en cualquier supervisión.'
}, {
  num: '02 / 04',
  title: 'El problema de la carpeta desorganizada',
  sin: 'Llegás a la supervisión con papeles sueltos, sin criterios documentados y sin evidencia clara del proceso evaluativo de cada alumno.',
  con: 'Checklist de carpeta didáctica al día, registro de desempeño trimestral para el legajo y calendario de evaluaciones 2026 completo.'
}, {
  num: '03 / 04',
  title: 'El problema de comunicar resultados',
  sin: 'No sabés cómo redactar el informe del alumno con dificultades ni cómo hablar con la familia sin que sea una situación incómoda.',
  con: 'Banco de frases para informes, modelos de notas para el cuaderno de comunicaciones y guía de recuperatorios lista para usar.'
}, {
  num: '04 / 04',
  title: 'El problema de la inclusión',
  sin: 'No tenés herramientas concretas para adaptar las evaluaciones de los alumnos con necesidades educativas específicas.',
  con: 'Plantilla de evaluación adaptada con tabla de ajustes posibles (tiempo, formato, consigna, material y respuesta) para cada situación.'
}];
export const MasterKitExplanation = () => {
  return <section className="py-20 bg-white" data-id="element-150">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-151">
        <div className="text-center mb-16" data-id="element-152">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-4" data-id="element-153">
            ¿QUÉ AGREGA EL MASTER KIT DE EVALUACIÓN™?
          </h2>
          <p className="text-xl text-brand-orange font-medium" data-id="element-154">
            Para docentes que quieren tener también las evaluaciones resueltas
          </p>
        </div>

        <div className="space-y-8" data-id="element-155">
          {problems.map((prob, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4
        }} className="bg-cream-dark rounded-2xl p-6 md:p-8 border border-brand-gold/20 shadow-sm" data-id="element-156">
              <div className="flex flex-col md:flex-row md:items-center gap-4 mb-6" data-id="element-157">
                <span className="text-brand-gold font-heading font-bold text-xl" data-id="element-158">
                  {prob.num}
                </span>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900" data-id="element-159">
                  {prob.title}
                </h3>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-160">
                <div className="bg-white p-5 rounded-xl border border-red-100" data-id="element-161">
                  <div className="flex items-center gap-2 text-red-600 font-bold mb-3" data-id="element-162">
                    <XCircle size={18} data-id="element-163" /> Sin Master Kit
                  </div>
                  <p className="text-gray-600 text-sm leading-relaxed" data-id="element-164">
                    {prob.sin}
                  </p>
                </div>

                <div className="bg-brand-green/5 p-5 rounded-xl border border-brand-green/20" data-id="element-165">
                  <div className="flex items-center gap-2 text-brand-green font-bold mb-3" data-id="element-166">
                    <CheckCircle2 size={18} data-id="element-167" /> Con Master Kit
                  </div>
                  <p className="text-gray-800 text-sm leading-relaxed font-medium" data-id="element-168">
                    {prob.con}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};